import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ICurrentStitchId = string | number | undefined;

export interface DashboardState {
  currentStitchId: ICurrentStitchId;
}

const initialState: DashboardState = {
  currentStitchId: undefined,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    updateDashboardCurrentStitchId: (state, action: PayloadAction<ICurrentStitchId>) => {
      state.currentStitchId = action.payload;
    },
    clearDashboardStitchId: (state) => {
      state.currentStitchId = undefined;
    },
    resetDashboardState: () => initialState,
  },
});

export const { updateDashboardCurrentStitchId } = dashboardSlice.actions;

export default dashboardSlice.reducer;
